<template>
    <nav
        class="nav-scroll sticky top-0 z-50 flex h-8 w-full items-center justify-center gap-3 overflow-x-auto
               border-b px-4 text-[9px] no-select transition-all duration-300 xs:text-[10px] sm:h-12 sm:gap-6
               sm:text-[11px] md:h-14 md:justify-between md:px-8 md:text-xs lg:gap-8 lg:text-[13px] 2xl:px-10
               4xl:text-[15px]"
        :class="isPastHeader ? 'border-foam/5 bg-void/70 backdrop-blur-md' : 'border-transparent'"
    >
        <router-link
            :to="{ name: 'home' }"
            class="hidden whitespace-nowrap font-light uppercase tracking-[0.4em] text-foam/80 hover:text-white md:block"
        >
            Funus
        </router-link>

        <div
            class="flex items-center gap-1 tracking-[length:var(--nav-tracking)] [--nav-tracking:0.1em]
                   xs:[--nav-tracking:0.16em] sm:gap-4 sm:[--nav-tracking:0.22em] md:gap-6
                   lg:[--nav-tracking:0.26em] h-full"
        >
            <router-link
                v-for="(route, i) in routes"
                :key="i"
                :to="{ name: route }"
                class="whitespace-nowrap uppercase text-foam/60 hover:text-white h-full px-2 flex items-center"
            >
                {{ route }}
            </router-link>
        </div>
    </nav>
</template>

<script>
    // Library
    import { defineComponent, onBeforeUnmount, onMounted, ref } from 'vue';

    export default defineComponent({
        name: 'NavBar',

        setup() {
            const isPastHeader = ref(false);

            const onScroll = () => {
                isPastHeader.value = window.scrollY > 40;
            };

            onMounted(() => {
                window.addEventListener('scroll', onScroll, { passive: true });

                onScroll();
            });

            onBeforeUnmount(() => {
                window.removeEventListener('scroll', onScroll);
            });

            return {
                routes: [
                    'about',
                    'releases',
                    'videos',
                    'press',
                    'reviews',
                    'shop',
                ],
                isPastHeader,
            };
        },
    });
</script>
